'use strict';
import React from 'react';
import classnames from 'classnames';

export default class FormField extends React.Component {


    /**
     * Perform shallow equals comparison of two redux-form field objects to
     * determine if the field has changed.
     */
    static fieldShallowEquals(field, nextField) {

        const FIELD_EVENT_HANDLER = /^(?:on|handle)[A-Z]/;

        for (var prop in field) {
            // Ignore event handlers, as they continually get recreated by redux-form
            if (!FIELD_EVENT_HANDLER.test(prop) && field[prop] !== nextField[prop]) {
                return false;
            }
        }
        return true;
    };


    /**
     * Perform shallow equals comparison to determine if the props of the context
     * form field component have changed, with special-case handling for the "field"
     * prop, provided by redux-form.
     * Use this as shouldComponentUpdate() on components which compose a
     * FormField in their render() method and they will only re-render when
     * necessary.
     */


    static propTypes = {

        field: React.PropTypes.object, // A redux-form field object
        help: React.PropTypes.string,
        inputClass: React.PropTypes.string,
        inputProps: React.PropTypes.object,
        label: React.PropTypes.string,
        loading: React.PropTypes.bool
    };


    static defaultProps = {
        field: {},
        inputProps: {}
    };


    renderHelp() {
        if (this.props.help) {
            return <div className="item__help">{help}</div>;
        }
        return null;
    }


    render() {

        var {field, inputClass, inputProps, label, loading } = this.props;
        var error = field.touched && field.error;

        return (
            <div className={classnames('group__item', {'group__item--error': error})}>
                {this.props.children}
                {this.renderHelp()}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./static/app/forms/formField.jsx